module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_8017.8b5d4b60.png";